import { render, staticRenderFns } from "./IconTrendingDownSolid.vue?vue&type=template&id=4c258ef8"
import script from "./IconTrendingDownSolid.vue?vue&type=script&lang=js"
export * from "./IconTrendingDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports